import React, { useEffect, useState } from "react";
import "../assets/css/index.css";
import { Avatar, Divider, Grid } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Link, useNavigate } from "react-router-dom";
import { getFile, GetUserData, Logout } from "../functions/authenticate";
import { View } from "@aws-amplify/ui-react";
import Box from "./base/Box";

export default function Topbar(props) {
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [userData, setUserData] = useState(null);
  const [profile, setProfile] = useState(null);
  const navigate = useNavigate();
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  useEffect(() => {
    getData();
  }, [props.dat]);

  const getData = async () => {
    let User = await GetUserData(navigate);
    if (User) {
      User = JSON.parse(User);
      setUserData(User);
      if (User.profile) {
        let imgL = await getFile(User.profile);
        if (imgL) {
          setProfile(imgL);
        }
      }
    }
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Grid container className="topbar" spacing={2} sx={{ zIndex: '1400' }}>
      <Grid 
        onClick={() => {
          navigate('/');
        }}
        className="logo" 
        sx={{cursor: 'pointer'}}>
        <img src="/media/logo.svg" />
      </Grid>
      <Grid className="topsubhead">
        <p className="topheading">{props.title}</p>
        <h1 className="topmheading">{props.subtitle}</h1>
      </Grid>
      <Box sx={{ flexGrow: 0, marginRight: 5 }}>
        <a href="#" onClick={handleOpenUserMenu} className="topuserarea">
          {profile ? (
            <img src={profile} className="profImgMSm" />
          ) : (
            <Avatar sx={{ bgcolor: "#0065c9" }}>
              {userData && userData.name.split("")[0]}
            </Avatar>
          )}
          <p className="avtext">
            <span style={{fontWeight: 'bold'}}>{userData && userData.name}</span> <br /> <span>User</span>
          </p>
          {Boolean(anchorElUser) ? (
            <ArrowDropDownIcon className="avico" />
          ) : (
            <ArrowRightIcon className="avico" />
          )}
        </a>

        <Menu
          sx={{ mt: "50px" }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          <div className="usermenavtdiv">
            {profile ? (
              <img src={profile} className="profImgMSm" />
            ) : (
              <Avatar sx={{ bgcolor: "#0065c9" }}>
                {userData && userData.name.split("")[0]}
              </Avatar>
            )}
            <p className="avtext">
              <span style={{fontWeight: 'bold'}}>{userData && userData.name}</span> <br /> <span>User</span>
            </p>
          </div>
          <Divider style={{ marginBottom: "5px" }} />
          <MenuItem
            key={"profile"}
            onClick={() => {
              navigate("Profile");
              handleCloseUserMenu();
            }}
          >
            <Typography className="useravmen"><span>Profile</span></Typography>
          </MenuItem>
          {/* Hide Help */}
          {/* <MenuItem key={"profile1"} onClick={handleCloseUserMenu}>
            <Typography className="useravmen">Help</Typography>
          </MenuItem> */}
          <Divider style={{ marginBottom: "5px", marginTop: "5px" }} />
          <MenuItem
            key={"profile2"}
            onClick={() => {
              Logout(navigate);
              handleCloseUserMenu();
            }}
          >
            <Typography className="useravmen"><span>Sign Out</span></Typography>
          </MenuItem>
        </Menu>
      </Box>
    </Grid>
  );
}
